// let redirectAttempted = false;
// let localizationRunCount = 0;

// const MAX_LOCALIZATION_RUNS = 8;

// /*
//  * ============================================================
//  * IPINFO
//  * ============================================================
//  */

// const IPINFO_TOKEN = 'bd3459666c414a';


// /*
//  * ============================================================
//  * MARKET CONFIGURATION
//  * ============================================================
//  */

// const MARKETS = {
//   RS: {
//     country: 'RS',
//     domain: 'https://www.beowald.rs',
//     locale: 'sr',
//   },

//   AT: {
//     country: 'AT',
//     domain: 'https://www.beowald.com',
//     locale: 'de',
//   },

//   DE: {
//     country: 'DE',
//     domain: 'https://www.beowald.com',
//     locale: 'de',
//   },

//   DEFAULT: {
//     country: 'AT',
//     domain: 'https://www.beowald.com',
//     locale: 'en',
//   },
// };


// /*
//  * ============================================================
//  * BOT DETECTION
//  * ============================================================
//  */

// function isBot() {
//   const ua = navigator.userAgent || '';

//   return /Googlebot|Google-InspectionTool|AdsBot-Google|Mediapartners-Google|bingbot|Bingbot|Slurp|DuckDuckBot|Baiduspider|YandexBot|facebookexternalhit|Twitterbot|LinkedInBot|WhatsApp|TelegramBot|Pinterestbot|AhrefsBot|SemrushBot|MJ12bot|DotBot/i.test(
//     ua
//   );
// }


// /*
//  * ============================================================
//  * GET CURRENT URL LOCALE
//  *
//  * /        -> en
//  * /de/     -> de
//  * /de/foo -> de
//  * /foo     -> en
//  * ============================================================
//  */

// function getPathLocale() {
//   const firstSegment = window.location.pathname
//     .split('/')
//     .filter(Boolean)[0];

//   if (firstSegment === 'de') {
//     return 'de';
//   }

//   if (firstSegment === 'sr') {
//     return 'sr';
//   }

//   return 'en';
// }


// /*
//  * ============================================================
//  * REMOVE LANGUAGE PREFIX
//  *
//  * /de/collection/foo -> /collection/foo
//  * /collection/foo    -> /collection/foo
//  * /                   -> /
//  * ============================================================
//  */

// function getCleanPath() {
//   let path = window.location.pathname;

//   path = path.replace(/^\/(de|en|sr)(?=\/|$)/, '');

//   if (!path.startsWith('/')) {
//     path = '/' + path;
//   }

//   if (path === '') {
//     path = '/';
//   }

//   return path;
// }


// /*
//  * ============================================================
//  * BUILD PATH FOR TARGET MARKET
//  * ============================================================
//  *
//  * RS:
//  *   https://www.beowald.rs/
//  *
//  * AT:
//  *   https://www.beowald.com/de/
//  *
//  * DE:
//  *   https://www.beowald.com/de/
//  *
//  * DEFAULT:
//  *   https://www.beowald.com/
//  * ============================================================
//  */

// function buildTargetUrl(targetMarket) {
//   const cleanPath = getCleanPath();

//   let targetPath = '/';


//   /*
//    * ----------------------------------------------------------
//    * SERBIA
//    *
//    * Serbia is a separate domain.
//    * There is NO /sr/ path.
//    * ----------------------------------------------------------
//    */

//   if (targetMarket.country === 'RS') {
//     targetPath = cleanPath;
//   }


//   /*
//    * ----------------------------------------------------------
//    * AUSTRIA / GERMANY
//    *
//    * German market = /de/
//    * English market = /
//    * ----------------------------------------------------------
//    */

//   else if (targetMarket.locale === 'de') {
//     if (cleanPath === '/') {
//       targetPath = '/de/';
//     } else {
//       targetPath = '/de' + cleanPath;
//     }
//   }

//   else {
//     targetPath = cleanPath;
//   }


//   return (
//     targetMarket.domain +
//     targetPath +
//     window.location.search +
//     window.location.hash
//   );
// }


// /*
//  * ============================================================
//  * GET VISITOR COUNTRY FROM IPINFO
//  * ============================================================
//  */

// async function getVisitorCountry() {
//   try {
//     console.log(
//       '[Localization] 🌍 Requesting visitor location from IPinfo...'
//     );

//     const response = await fetch(
//       `https://ipinfo.io/json?token=${encodeURIComponent(IPINFO_TOKEN)}`,
//       {
//         method: 'GET',
//         cache: 'no-store',
//       }
//     );

//     if (!response.ok) {
//       throw new Error(
//         `IPinfo HTTP ${response.status}`
//       );
//     }

//     const data = await response.json();

//     const country = String(data.country || '')
//       .trim()
//       .toUpperCase();

//     console.log(
//       '[Localization] 🌍 IPinfo response:',
//       {
//         country: country,
//         region: data.region,
//         city: data.city,
//         timezone: data.timezone,
//       }
//     );

//     if (!country) {
//       console.warn(
//         '[Localization] ⚠️ IPinfo did not return a country.'
//       );

//       return null;
//     }

//     return country;

//   } catch (error) {
//     console.error(
//       '[Localization] ❌ IPinfo lookup failed:',
//       error
//     );

//     return null;
//   }
// }


// /*
//  * ============================================================
//  * DETERMINE TARGET MARKET
//  * ============================================================
//  */

// function getTargetMarket(visitorCountry) {

//   /*
//    * Serbia
//    */

//   if (visitorCountry === 'RS') {
//     return {
//       ...MARKETS.RS,
//     };
//   }


//   /*
//    * Austria
//    */

//   if (visitorCountry === 'AT') {
//     return {
//       ...MARKETS.AT,
//     };
//   }


//   /*
//    * Germany
//    */

//   if (visitorCountry === 'DE') {
//     return {
//       ...MARKETS.DE,
//     };
//   }


//   /*
//    * Everyone else
//    *
//    * Standard English .com
//    */

//   return {
//     ...MARKETS.DEFAULT,
//   };
// }


// /*
//  * ============================================================
//  * NORMALIZE URL
//  * ============================================================
//  */

// function normalizeUrl(url) {
//   try {
//     const parsed = new URL(url);

//     let pathname = parsed.pathname;

//     /*
//      * Normalize trailing slash.
//      */

//     if (pathname.length > 1) {
//       pathname = pathname.replace(/\/+$/, '');
//     }

//     return (
//       parsed.origin.toLowerCase() +
//       pathname +
//       parsed.search +
//       parsed.hash
//     );

//   } catch {
//     return url;
//   }
// }


// /*
//  * ============================================================
//  * CHECK WHETHER CURRENT URL IS ALREADY CORRECT
//  * ============================================================
//  */

// function isCorrectUrl(targetUrl) {
//   const currentUrl =
//     window.location.origin +
//     window.location.pathname +
//     window.location.search +
//     window.location.hash;

//   return (
//     normalizeUrl(currentUrl) ===
//     normalizeUrl(targetUrl)
//   );
// }


// /*
//  * ============================================================
//  * SHOPIFY COUNTRY FORM
//  * ============================================================
//  */

// function getCountryForm() {
//   return document.getElementById(
//     'DrawerMenuCountryForm'
//   );
// }


// /*
//  * ============================================================
//  * GET SHOPIFY COUNTRY INPUT
//  * ============================================================
//  */

// function getCountryInput(countryForm) {
//   return countryForm?.querySelector(
//     'input[name="country_code"]'
//   );
// }


// /*
//  * ============================================================
//  * CHANGE SHOPIFY COUNTRY
//  *
//  * This is used for the .com market.
//  *
//  * Shopify needs to know:
//  *
//  * AT -> AT
//  * DE -> DE
//  *
//  * Serbia is handled as a separate domain and therefore
//  * does NOT rely on the .com localization form for the
//  * final redirect.
//  * ============================================================
//  */

// function submitShopifyLocalization(
//   countryForm,
//   countryInput,
//   targetMarket,
//   targetUrl
// ) {
//   console.log(
//     '[Localization] 🛒 Updating Shopify market:',
//     targetMarket.country
//   );

//   /*
//    * Set country.
//    */

//   countryInput.value = targetMarket.country;


//   /*
//    * Remove duplicate country_code fields.
//    */

//   countryForm
//     .querySelectorAll('input[name="country_code"]')
//     .forEach((input) => {
//       if (input !== countryInput) {
//         input.remove();
//       }
//     });


//   /*
//    * Shopify return_to.
//    */

//   let returnToInput = countryForm.querySelector(
//     'input[name="return_to"]'
//   );

//   if (!returnToInput) {
//     returnToInput = document.createElement('input');

//     returnToInput.type = 'hidden';
//     returnToInput.name = 'return_to';

//     countryForm.appendChild(returnToInput);
//   }

//   returnToInput.value = targetUrl;


//   console.log(
//     '[Localization] 🛒 Shopify return_to:',
//     targetUrl
//   );


//   /*
//    * Submit.
//    */

//   setTimeout(() => {
//     console.log(
//       '[Localization] 🚀 Submitting Shopify localization form...'
//     );

//     countryForm.submit();
//   }, 150);
// }


// /*
//  * ============================================================
//  * DIRECT DOMAIN REDIRECT
//  * ============================================================
//  */

// function redirectToDomain(targetUrl) {
//   console.log(
//     '[Localization] 🌐 Direct domain redirect:',
//     targetUrl
//   );

//   sessionStorage.setItem(
//     'localizationLastTarget',
//     targetUrl
//   );

//   sessionStorage.setItem(
//     'localizationRedirectTimestamp',
//     String(Date.now())
//   );

//   sessionStorage.setItem(
//     'localizationRedirected',
//     'true'
//   );

//   window.location.replace(targetUrl);
// }


// /*
//  * ============================================================
//  * REDIRECT LOOP PROTECTION
//  * ============================================================
//  */

// function recentlyRedirectedTo(targetUrl) {
//   const lastTarget = sessionStorage.getItem(
//     'localizationLastTarget'
//   );

//   const timestamp = Number(
//     sessionStorage.getItem(
//       'localizationRedirectTimestamp'
//     ) || '0'
//   );

//   const age = Date.now() - timestamp;

//   /*
//    * Only block the exact same destination for 30 seconds.
//    */

//   return (
//     lastTarget === targetUrl &&
//     age < 30000
//   );
// }


// /*
//  * ============================================================
//  * MAIN LOCALIZATION LOGIC
//  * ============================================================
//  */

// const waitForLocalization = setInterval(
//   async () => {

//     localizationRunCount++;

//     console.log(
//       `[Localization] Running... Attempt ${localizationRunCount}/${MAX_LOCALIZATION_RUNS}`
//     );


//     /*
//      * --------------------------------------------------------
//      * MAX ATTEMPTS
//      * --------------------------------------------------------
//      */

//     if (localizationRunCount >= MAX_LOCALIZATION_RUNS) {
//       clearInterval(waitForLocalization);

//       console.log(
//         '[Localization] 🛑 Maximum attempts reached.'
//       );
//     }


//     /*
//      * --------------------------------------------------------
//      * SHOPIFY DESIGN MODE
//      * --------------------------------------------------------
//      */

//     if (
//       typeof Shopify !== 'undefined' &&
//       Shopify.designMode
//     ) {
//       console.log(
//         '[Localization] 🛠 Shopify design mode detected. Skipping.'
//       );

//       clearInterval(waitForLocalization);

//       return;
//     }


//     /*
//      * --------------------------------------------------------
//      * BOT
//      * --------------------------------------------------------
//      */

//     if (isBot()) {
//       console.log(
//         '[Localization] 🤖 Bot detected. Skipping.'
//       );

//       clearInterval(waitForLocalization);

//       return;
//     }


//     /*
//      * --------------------------------------------------------
//      * SHOPIFY COUNTRY FORM
//      * --------------------------------------------------------
//      */

//     const countryForm = getCountryForm();
//     const countryInput = getCountryInput(countryForm);


//     if (!countryForm || !countryInput) {
//       console.log(
//         '[Localization] ⏳ Country localization form not ready yet.'
//       );

//       return;
//     }


//     console.log(
//       '[Localization] ✅ Country localization form found.'
//     );


//     /*
//      * Stop polling.
//      */

//     clearInterval(waitForLocalization);


//     /*
//      * Prevent duplicate execution.
//      */

//     if (redirectAttempted) {
//       console.log(
//         '[Localization] Already processed.'
//       );

//       return;
//     }

//     redirectAttempted = true;


//     /*
//      * --------------------------------------------------------
//      * CURRENT STATE
//      * --------------------------------------------------------
//      */

//     const currentCountry = String(
//       countryInput.value || ''
//     ).toUpperCase();

//     const currentLocale = getPathLocale();

//     const currentOrigin =
//       window.location.origin;


//     console.log(
//       '[Localization] Current Shopify country:',
//       currentCountry
//     );

//     console.log(
//       '[Localization] Current URL locale:',
//       currentLocale
//     );

//     console.log(
//       '[Localization] Current origin:',
//       currentOrigin
//     );


//     /*
//      * --------------------------------------------------------
//      * IPINFO
//      * --------------------------------------------------------
//      */

//     const visitorCountry =
//       await getVisitorCountry();


//     /*
//      * If IPinfo fails, do nothing.
//      *
//      * This is deliberate.
//      *
//      * We don't want a temporary IPinfo/API problem to
//      * randomly move customers between markets.
//      */

//     if (!visitorCountry) {
//       console.log(
//         '[Localization] ⚠️ Visitor country unavailable. No redirect.'
//       );

//       return;
//     }


//     /*
//      * --------------------------------------------------------
//      * TARGET MARKET
//      * --------------------------------------------------------
//      */

//     const targetMarket =
//       getTargetMarket(visitorCountry);


//     /*
//      * Build final URL.
//      */

//     const targetUrl =
//       buildTargetUrl(targetMarket);


//     console.log(
//       '[Localization] 🎯 Visitor country:',
//       visitorCountry
//     );

//     console.log(
//       '[Localization] 🎯 Target market:',
//       targetMarket
//     );

//     console.log(
//       '[Localization] 🎯 Target URL:',
//       targetUrl
//     );


//     /*
//      * --------------------------------------------------------
//      * ALREADY CORRECT?
//      * --------------------------------------------------------
//      */

//     if (isCorrectUrl(targetUrl)) {
//       console.log(
//         '[Localization] ✅ Already on correct market.'
//       );

//       sessionStorage.setItem(
//         'localizationRedirected',
//         'true'
//       );

//       return;
//     }


//     /*
//      * --------------------------------------------------------
//      * LOOP PROTECTION
//      * --------------------------------------------------------
//      */

//     if (recentlyRedirectedTo(targetUrl)) {
//       console.log(
//         '[Localization] 🛑 Same redirect was recently attempted. Stopping.'
//       );

//       return;
//     }


//     /*
//      * --------------------------------------------------------
//      * SERBIA
//      *
//      * .rs is a completely separate domain.
//      *
//      * Do NOT submit the .com Shopify localization form
//      * and expect it to change the hostname.
//      * --------------------------------------------------------
//      */

//     if (targetMarket.country === 'RS') {

//       console.log(
//         '[Localization] 🇷🇸 Serbia detected.'
//       );

//       console.log(
//         '[Localization] 🇷🇸 Redirecting to .rs domain.'
//       );

//       redirectToDomain(targetUrl);

//       return;
//     }


//     /*
//      * --------------------------------------------------------
//      * AUSTRIA / GERMANY
//      *
//      * Both use .com.
//      *
//      * Both use /de/.
//      *
//      * We let Shopify handle the country market and use
//      * return_to to get to the correct language URL.
//      * --------------------------------------------------------
//      */

//     if (
//       targetMarket.country === 'AT' ||
//       targetMarket.country === 'DE'
//     ) {

//       console.log(
//         '[Localization] 🇪🇺 .com German market detected.'
//       );


//       /*
//        * If we're already on .com and the Shopify country
//        * is correct, we only need to move to /de/.
//        */

//       if (
//         currentOrigin ===
//         targetMarket.domain &&
//         currentCountry ===
//         targetMarket.country
//       ) {

//         console.log(
//           '[Localization] 🇩🇪/🇦🇹 Country already correct. Redirecting to /de/.'
//         );

//         redirectToDomain(targetUrl);

//         return;
//       }


//       /*
//        * Otherwise use Shopify's localization form.
//        */

//       submitShopifyLocalization(
//         countryForm,
//         countryInput,
//         targetMarket,
//         targetUrl
//       );

//       return;
//     }


//     /*
//      * --------------------------------------------------------
//      * DEFAULT ENGLISH .COM
//      * --------------------------------------------------------
//      */

//     if (
//       targetMarket.country === 'AT' &&
//       targetMarket.locale === 'en'
//     ) {

//       console.log(
//         '[Localization] 🌍 Default English .com market.'
//       );

//       redirectToDomain(targetUrl);

//       return;
//     }


//   },
//   800
// );
let redirectAttempted = false;
let localizationRunCount = 0;

const MAX_LOCALIZATION_RUNS = 8;
const IPINFO_TOKEN = 'bd3459666c414a';

/*
 * ============================================================
 * MARKET CONFIGURATION
 * ============================================================
 */

const MARKETS = {
  RS: {
    key: 'RS',
    country: 'RS',
    domain: 'https://www.beowald.rs',
    locale: 'sr',
  },

  AT: {
    key: 'AT',
    country: 'AT',
    domain: 'https://www.beowald.com',
    locale: 'de',
  },

  DE: {
    key: 'DE',
    country: 'DE',
    domain: 'https://www.beowald.com',
    locale: 'de',
  },

  DEFAULT: {
    key: 'DEFAULT',
    country: 'AT',
    domain: 'https://www.beowald.com',
    locale: 'en',
  },
};

/*
 * ============================================================
 * BOT DETECTION
 * ============================================================
 */

function isBot() {
  const ua = navigator.userAgent || '';

  return /Googlebot|Google-InspectionTool|AdsBot-Google|Mediapartners-Google|bingbot|Bingbot|Slurp|DuckDuckBot|Baiduspider|YandexBot|facebookexternalhit|Twitterbot|LinkedInBot|WhatsApp|TelegramBot|Pinterestbot|AhrefsBot|SemrushBot|MJ12bot|DotBot/i.test(
    ua
  );
}

/*
 * ============================================================
 * GET CURRENT URL LOCALE
 * ============================================================
 */

function getPathLocale() {
  const firstSegment = window.location.pathname
    .split('/')
    .filter(Boolean)[0];

  if (firstSegment === 'de') return 'de';
  if (firstSegment === 'sr') return 'sr';

  return 'en';
}

/*
 * ============================================================
 * REMOVE LANGUAGE PREFIX
 * ============================================================
 */

function getCleanPath() {
  let path = window.location.pathname;

  path = path.replace(/^\/(de|en|sr)(?=\/|$)/, '');

  if (!path.startsWith('/')) {
    path = '/' + path;
  }

  return path || '/';
}

/*
 * ============================================================
 * BUILD TARGET PATH & FULL URL
 * ============================================================
 */

function buildTargetRelativePath(targetMarket) {
  const cleanPath = getCleanPath();
  let targetPath = '/';

  if (targetMarket.country === 'RS') {
    targetPath = cleanPath;
  } else if (targetMarket.locale === 'de') {
    targetPath = cleanPath === '/' ? '/de/' : '/de' + cleanPath;
  } else {
    targetPath = cleanPath;
  }

  return targetPath + window.location.search + window.location.hash;
}

function buildTargetUrl(targetMarket) {
  return targetMarket.domain + buildTargetRelativePath(targetMarket);
}

/*
 * ============================================================
 * GET VISITOR COUNTRY FROM IPINFO (WITH SESSION CACHE)
 * ============================================================
 */

async function getVisitorCountry() {
  const cachedCountry = sessionStorage.getItem('localizationVisitorCountry');
  if (cachedCountry) {
    return cachedCountry;
  }

  try {
    console.log('[Localization] 🌍 Requesting visitor location from IPinfo...');

    const response = await fetch(
      `https://ipinfo.io/json?token=${encodeURIComponent(IPINFO_TOKEN)}`,
      {
        method: 'GET',
        cache: 'no-store',
      }
    );

    if (!response.ok) {
      throw new Error(`IPinfo HTTP ${response.status}`);
    }

    const data = await response.json();
    const country = String(data.country || '').trim().toUpperCase();

    if (!country) {
      console.warn('[Localization] ⚠️ IPinfo did not return a country.');
      return null;
    }

    sessionStorage.setItem('localizationVisitorCountry', country);
    return country;
  } catch (error) {
    console.error('[Localization] ❌ IPinfo lookup failed:', error);
    return null;
  }
}

/*
 * ============================================================
 * DETERMINE TARGET MARKET
 * ============================================================
 */

function getTargetMarket(visitorCountry) {
  if (visitorCountry === 'RS') return { ...MARKETS.RS };
  if (visitorCountry === 'AT') return { ...MARKETS.AT };
  if (visitorCountry === 'DE') return { ...MARKETS.DE };

  return { ...MARKETS.DEFAULT };
}

/*
 * ============================================================
 * NORMALIZE URL & CHECK STATE
 * ============================================================
 */

function normalizeUrl(url) {
  try {
    const parsed = new URL(url);
    let pathname = parsed.pathname;

    if (pathname.length > 1) {
      pathname = pathname.replace(/\/+$/, '');
    }

    return (
      parsed.origin.toLowerCase() +
      pathname +
      parsed.search +
      parsed.hash
    );
  } catch {
    return url;
  }
}

function isCorrectUrl(targetUrl) {
  const currentUrl =
    window.location.origin +
    window.location.pathname +
    window.location.search +
    window.location.hash;

  return normalizeUrl(currentUrl) === normalizeUrl(targetUrl);
}

/*
 * ============================================================
 * SHOPIFY COUNTRY FORM HELPERS
 * ============================================================
 */

function getCountryForm() {
  return document.getElementById('DrawerMenuCountryForm');
}

function getCountryInput(countryForm) {
  return countryForm?.querySelector('input[name="country_code"]');
}

/*
 * ============================================================
 * REDIRECT LOOP PROTECTION
 * ============================================================
 */

function markRedirectAttempt(targetUrl) {
  sessionStorage.setItem('localizationLastTarget', normalizeUrl(targetUrl));
  sessionStorage.setItem('localizationRedirectTimestamp', String(Date.now()));
  sessionStorage.setItem('localizationRedirected', 'true');
}

function recentlyRedirectedTo(targetUrl) {
  const lastTarget = sessionStorage.getItem('localizationLastTarget');
  const timestamp = Number(
    sessionStorage.getItem('localizationRedirectTimestamp') || '0'
  );
  const age = Date.now() - timestamp;

  return lastTarget === normalizeUrl(targetUrl) && age < 30000;
}

/*
 * ============================================================
 * SUBMIT SHOPIFY LOCALIZATION FORM (.COM)
 * ============================================================
 */

function submitShopifyLocalization(
  countryForm,
  countryInput,
  targetMarket,
  targetUrl
) {
  const relativeReturnTo = buildTargetRelativePath(targetMarket);

  console.log(
    '[Localization] 🛒 Updating Shopify market:',
    targetMarket.country,
    'Locale:',
    targetMarket.locale,
    'Return to:',
    relativeReturnTo
  );

  // 1. Record redirect BEFORE submitting so the reloaded page won't loop
  markRedirectAttempt(targetUrl);

  // 2. Set country_code and remove duplicates
  countryInput.value = targetMarket.country;
  countryForm
    .querySelectorAll('input[name="country_code"]')
    .forEach((input) => {
      if (input !== countryInput) input.remove();
    });

  // 3. Set locale_code so Shopify switches language at the same time
  let localeInput = countryForm.querySelector('input[name="locale_code"]');
  if (!localeInput) {
    localeInput = document.createElement('input');
    localeInput.type = 'hidden';
    localeInput.name = 'locale_code';
    countryForm.appendChild(localeInput);
  }
  localeInput.value = targetMarket.locale;

  // 4. Set return_to (MUST be a relative path for Shopify)
  let returnToInput = countryForm.querySelector('input[name="return_to"]');
  if (!returnToInput) {
    returnToInput = document.createElement('input');
    returnToInput.type = 'hidden';
    returnToInput.name = 'return_to';
    countryForm.appendChild(returnToInput);
  }
  returnToInput.value = relativeReturnTo;

  setTimeout(() => {
    console.log('[Localization] 🚀 Submitting Shopify localization form...');
    countryForm.submit();
  }, 150);
}

/*
 * ============================================================
 * DIRECT DOMAIN REDIRECT
 * ============================================================
 */

function redirectToDomain(targetUrl) {
  console.log('[Localization] 🌐 Direct domain redirect:', targetUrl);
  markRedirectAttempt(targetUrl);
  window.location.replace(targetUrl);
}

/*
 * ============================================================
 * MAIN LOCALIZATION LOGIC
 * ============================================================
 */

const waitForLocalization = setInterval(async () => {
  localizationRunCount++;

  if (localizationRunCount >= MAX_LOCALIZATION_RUNS) {
    clearInterval(waitForLocalization);
    console.log('[Localization] 🛑 Maximum attempts reached.');
  }

  // Skip in Shopify Theme Editor
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    clearInterval(waitForLocalization);
    return;
  }

  // Skip for search/social bots
  if (isBot()) {
    clearInterval(waitForLocalization);
    return;
  }

  // If we already localized the user in this browser session, don't override them again
  if (sessionStorage.getItem('localizationRedirected') === 'true') {
    console.log('[Localization] ✅ Session already localized. Skipping.');
    clearInterval(waitForLocalization);
    return;
  }

  const countryForm = getCountryForm();
  const countryInput = getCountryInput(countryForm);

  if (!countryForm || !countryInput) {
    console.log('[Localization] ⏳ Country localization form not ready yet.');
    return;
  }

  clearInterval(waitForLocalization);

  if (redirectAttempted) return;
  redirectAttempted = true;

  const currentCountry = String(countryInput.value || '').toUpperCase();
  const currentOrigin = window.location.origin;

  const visitorCountry = await getVisitorCountry();
  if (!visitorCountry) {
    console.log('[Localization] ⚠️ Visitor country unavailable. No redirect.');
    return;
  }

  const targetMarket = getTargetMarket(visitorCountry);
  const targetUrl = buildTargetUrl(targetMarket);

  console.log('[Localization] 🎯 State:', {
    visitorCountry,
    currentCountry,
    currentOrigin,
    targetMarket,
    targetUrl,
  });

  // Check if BOTH the URL and the Shopify country match the target
  const urlMatches = isCorrectUrl(targetUrl);
  const countryMatches =
    targetMarket.key === 'RS' || currentCountry === targetMarket.country;

  if (urlMatches && countryMatches) {
    console.log('[Localization] ✅ Already on correct market and URL.');
    sessionStorage.setItem('localizationRedirected', 'true');
    return;
  }

  // Loop protection check
  if (recentlyRedirectedTo(targetUrl)) {
    console.log('[Localization] 🛑 Same redirect was recently attempted. Stopping.');
    return;
  }

  // 1. SERBIA (.rs separate domain)
  if (targetMarket.key === 'RS') {
    redirectToDomain(targetUrl);
    return;
  }

  // 2. .COM MARKETS (AT, DE, and DEFAULT)
  // If the visitor is currently on .rs but belongs on .com, do a direct domain redirect first
  if (currentOrigin !== targetMarket.domain) {
    redirectToDomain(targetUrl);
    return;
  }

  // If already on .com and Shopify country matches, just navigate to the target URL path
  if (currentCountry === targetMarket.country) {
    redirectToDomain(targetUrl);
    return;
  }

  // Otherwise, submit the Shopify localization form to update both country_code and locale_code
  submitShopifyLocalization(
    countryForm,
    countryInput,
    targetMarket,
    targetUrl
  );
}, 800);